import { createAction } from '@reduxjs/toolkit';
import type { IAiGenerateImageRequest, IGenerateImageEnd } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

export const generateImageStart = createAction<IAiGenerateImageRequest>('aiPhotoGeneration/generateImageStart');

export const generateImageEnd = createAction<IGenerateImageEnd>('aiPhotoGeneration/generateImageEnd');

export const resetImageGeneration = createAction('aiPhotoGeneration/resetImageGeneration');

export const incrementImageGenerationPercentage = createAction('aiPhotoGeneration/incrementImageGenerationPercentage');

export const cancelImageGeneration = createAction('aiPhotoGeneration/cancel');

export const saveGeneratedImage = createAction('aiPhotoGeneration/saveGeneratedImage');

export const addGenerationRequest = createAction('aiPhotoGeneration/addAiGenerationRequest');
